const swapTitle = {
  "/": "dashboard",
  "/settings": "update password",
  "/user": "users",
  "/notifications": "notifications",
  "/cancelled": "cancelled orders",
  "/completed": "completed orders",
  "/overdue": "overdue orders",
  "/ongoing": "ongoing orders",
  "/ova": "Quip and Stockbank orders",
  "/pricing": "pricing error for flite",
  "/tickets": "tickets",
  "/inventory-upload": "inventory-upload",
  "/inventory-upload/upload": "upload",
  "/riders": "Dispatch Riders",
  "/hospitals": "lifebank hospitals",
  "/vendors": "vendors",
  "/cylinders": "cylinders",
  "/cylinders/:id": "cylinder Series",

  "/track-order/:id": "ORDER TRACKER",
};

export default swapTitle;
